import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wwd-tab3',
  templateUrl: './wwdtab3.component.html',
  styleUrls: ['./wwdtabs.component.scss']
})
export class WhatWeDoTab3Component{
  activeTab = 1;

  setActiveTab(tab){
    this.activeTab = tab;
  }
  
}